import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { deleteCategory, editCategory, fetchCategoryList, openGlobalPopup } from '../../redux/action';
import React, { useEffect, useState } from 'react';
import CommonSearchBox from "../../component/SearchBox/CommomSearchBox"
import ConfirmBox from "../Popup/ConfirmBox";
import EmptyScreen from "../common/EmptyScreen";
import MapCategoryAddonForm from "./MapCategoryAddonForm";
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { useTranslation } from "react-i18next";
import { 
EyeIcon,
Eye,
EyeClosed,
Edit,
EditIcon,
Edit2,
Layers
} from "lucide-react";


const mockCategories = [
  { categoryId: 1, image: "https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a", name: "Starters", description: "Appetizers and small bites" },
  { categoryId: 2, image: "https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a", name: "Main Course", description: "Hearty meals" },
  { categoryId: 3, image: "https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a", name: "Desserts", description: "Sweet treats" },
];

function CategoryList({ onEdit }) {
  const { t } = useTranslation();
  const [deleteCategories, setIsDeleteCategories] = useState('');
  const categoriesObj = useSelector((state) => state.admin?.categories) || [];
  const categories = Array.isArray(categoriesObj) ? categoriesObj : Object.values(categoriesObj);
  console.log("categories", categories)
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
   const [selectedCategoryForAddon, setSelectedCategoryForAddon] = useState(null);
 

  useEffect(() => {
    dispatch(fetchCategoryList());
    dispatch({ type: "FETCH_ADDON_GROUPS" });
  }, [dispatch]);


  const filteredcategories = Object.values(categories).filter((category) =>
    category.categoryName.toLowerCase().includes(search.toLowerCase()));

  const handleDelete = (categoryId) => {
    setIsDeleteCategories(categoryId)
    dispatch(openGlobalPopup("confirm-box"));
  };

  const handleEdit = (cat) => {
    // In a real application, you'd usually open a modal or navigate to an edit form.
    // For demonstration, we'll use a prompt to simulate getting new data.
    console.log('user', cat)
    dispatch(editCategory(cat));
    onEdit();
  };

  return (
    <div className="table-container">

      <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Categories")} ({Object.keys(filteredcategories).length})</h3>
      <CommonSearchBox
        placeholder="Search category by name..."
        search={search}
        setSearch={setSearch}
      />

      {Object.keys(filteredcategories).length === 0 ? (
        <EmptyScreen message="No categories found. Please add a category." />
      ) : (
        <>
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                {/* <th>Description</th> */}
                <th>Foods</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredcategories.map((cat) => (
                <tr key={cat.categoryId}>
                  {/* <td > <img src={cat.categoryImage} title="" alt="" className="itemImage" /></td> */}
                  <td>{cat.categoryName}</td>
                  <td>
                    {/* Navigate to foods under this category */}
                    <Link to={`/menu-categories/${cat.categoryId}/foods`} className="view-link app-back-btn"
                      state={{ category: cat, allCategories: categories }}>
                        <Eye size={16} color="var(--ui-warning-text)" className="sidebar-icon" />
                        {t("View & add items")} ({Number(cat.foodItemCount) || 0})
                    </Link>
                  </td>
                  <td>
                    <span
                      className="edit-icon link-btn"
                      title="Edit"
                      aria-label="Edit"
                      onClick={() => handleEdit(cat)}
                    >
                      ✎
                    </span>

                    <span
                      className="delete-icon link-btn danger"
                      title="Delete"
                      aria-label="Delete"
                      onClick={() => handleDelete(cat.categoryId)}
                    >
                      ✖
                    </span>

                    <button
  type="button"
  className="view-link app-back-btn"
  style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "10px" }}
  onClick={() => {
    setSelectedCategoryForAddon(cat);
    dispatch(openGlobalPopup("map-category-addon"));
  }}
>
  <Layers size={16} color="#0284c7" />
  Add-ons
</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> 
          </div>
        </>
      )}
      <ConfirmBox
        variant="delete"
        title={"Are you sure you want to delete this category?"}
        onConfirm={() => {
          dispatch(deleteCategory(deleteCategories));
        }}
        onCancel={() => {
          setIsDeleteCategories('');
        }} />

        <GlobalPopup
  popupKey="map-category-addon"
  title={`Map Add-ons: ${selectedCategoryForAddon?.categoryName || ""}`}
  onClose={() => setSelectedCategoryForAddon(null)}
>
  <MapCategoryAddonForm category={selectedCategoryForAddon} />
</GlobalPopup>
    </div>
  )
}

export default CategoryList;
